import script from "./AccidentChildren.vue?vue&type=script&setup=true&lang=js"
export * from "./AccidentChildren.vue?vue&type=script&setup=true&lang=js"

import "./AccidentChildren.vue?vue&type=style&index=0&id=20624f4b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20624f4b"]])

export default __exports__